import React from "react";


import { Col } from "react-bootstrap";


import FormSectionComponent from "@Components/Forms/@Form/@FormContent/FormSection";
import ButtonComponent from "@Components/Forms/Buttons/Button";


import "./index.scss";


type FormSubmitSectionComponentProps = {
    buttonText: string;
    buttonCallback: () => void;
    children?: React.ReactNode | React.ReactNode[];
};


export const FormSubmitSectionComponent:React.FC<FormSubmitSectionComponentProps> = ({
    buttonText, buttonCallback, children
}) => {

    return (
        <FormSectionComponent className={'submit-form-section-component'}>

            <Col xs={12} className={'submit-form-section-component__submit-button'}>
                <ButtonComponent
                    type={'cta'} size={'l'}
                    text={buttonText} callback={buttonCallback}
                />
            </Col>

            {children &&
            <Col xs={12} className={'submit-form-section-component__extra-content'}>
                {children}
            </Col>
            }

        </FormSectionComponent>
    );

};


export default FormSubmitSectionComponent;
